import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const Storage = {}
export default new Vuex.Store(Storage)
